module.exports = __webpack_public_path__ + "img/en.97713f41.svg";